import { collection, query, where } from 'firebase/firestore';
import { normalizeRole } from './accessControl.js';

export const NAV_BADGE_KEYS = {
  ORDER_QUEUE: 'order_queue',
  SALES_APPROVAL: 'sales_approval',
  CREDIT_APPROVAL: 'credit_approval',
  BILL_OF_MATERIAL: 'bill_of_material',
  BOM_DRAFT: 'bom_draft',
  BOM_PENDING_OPS_APPROVAL: 'bom_pending_ops_approval',
  PACKAGING_AND_STAGING: 'packaging_and_staging',
  PACKAGING_AND_STAGING_OPS: 'packaging_and_staging_ops',
  PACKAGING_AND_STAGING_WAREHOUSE: 'packaging_and_staging_warehouse',
  DELIVERY_CHALLAN: 'delivery_challan',
  DELIVERY_CHALLAN_OPS: 'delivery_challan_ops',
  DELIVERY_CHALLAN_WAREHOUSE: 'delivery_challan_warehouse',
  QUALITY_CHECK: 'quality_check',
  QUALITY_CHECK_WAREHOUSE: 'quality_check_warehouse',
  IN_TRANSIT: 'in_transit',
  INVOICE_PENDING: 'invoice_pending'
};

export const createNavBadgeQueries = (db) => ({
  [NAV_BADGE_KEYS.BOM_DRAFT]: query(
    collection(db, 'dispatches'),
    where('dispatchStatus', '==', 'moc_draft')
  ),
  [NAV_BADGE_KEYS.BOM_PENDING_OPS_APPROVAL]: query(
    collection(db, 'dispatches'),
    where('dispatchStatus', '==', 'pending_ops_approval')
  ),
  [NAV_BADGE_KEYS.PACKAGING_AND_STAGING_OPS]: query(
    collection(db, 'dispatches'),
    where('dispatchStatus', '==', 'packing_queued')
  ),
  [NAV_BADGE_KEYS.PACKAGING_AND_STAGING_WAREHOUSE]: query(
    collection(db, 'dispatches'),
    where('dispatchStatus', '==', 'packing_scheduled')
  ),
  [NAV_BADGE_KEYS.DELIVERY_CHALLAN_OPS]: query(
    collection(db, 'dispatches'),
    where('dispatchStatus', 'in', ['packed_ready', 'ewaybill_pending', 'invoice_ready'])
  ),
  [NAV_BADGE_KEYS.DELIVERY_CHALLAN_WAREHOUSE]: query(
    collection(db, 'dispatches'),
    where('dispatchStatus', 'in', ['invoice_ready', 'ewaybill_complete'])
  ),
  [NAV_BADGE_KEYS.QUALITY_CHECK_WAREHOUSE]: query(
    collection(db, 'dispatches'),
    where('dispatchStatus', 'in', ['invoice_ready', 'ewaybill_complete'])
  ),
  [NAV_BADGE_KEYS.IN_TRANSIT]: query(
    collection(db, 'dispatches'),
    where('dispatchStatus', '==', 'dispatched')
  ),
  [NAV_BADGE_KEYS.ORDER_QUEUE]: query(
    collection(db, 'orders'),
    where('status', '==', 'in_que')
  ),
  [NAV_BADGE_KEYS.SALES_APPROVAL]: query(
    collection(db, 'orders'),
    where('status', '==', 'pending_approval')
  ),
  [NAV_BADGE_KEYS.CREDIT_APPROVAL]: query(
    collection(db, 'orders'),
    where('status', '==', 'pending_finance')
  ),
  [NAV_BADGE_KEYS.INVOICE_PENDING]: query(
    collection(db, 'dispatches'),
    where('dispatchStatus', '==', 'invoice_pending')
  )
});

export const getBillOfMaterialBadgeKey = (role) => {
  switch (normalizeRole(role)) {
    case 'ops_manager':
      return NAV_BADGE_KEYS.BOM_PENDING_OPS_APPROVAL;
    case 'ops':
      return NAV_BADGE_KEYS.BOM_DRAFT;
    default:
      return NAV_BADGE_KEYS.BOM_DRAFT;
  }
};

export const getPackagingAndStagingBadgeKey = (role) => {
  switch (normalizeRole(role)) {
    case 'warehouse':
      return NAV_BADGE_KEYS.PACKAGING_AND_STAGING_WAREHOUSE;
    case 'ops_manager':
    case 'ops':
      return NAV_BADGE_KEYS.PACKAGING_AND_STAGING_OPS;
    default:
      return NAV_BADGE_KEYS.PACKAGING_AND_STAGING_OPS;
  }
};

export const getDeliveryChallanBadgeKey = (role) => {
  switch (normalizeRole(role)) {
    case 'warehouse':
      return null;
    case 'ops_manager':
    case 'ops':
      return NAV_BADGE_KEYS.DELIVERY_CHALLAN_OPS;
    default:
      return NAV_BADGE_KEYS.DELIVERY_CHALLAN_OPS;
  }
};

export const getQualityCheckBadgeKey = (role) => {
  switch (normalizeRole(role)) {
    case 'warehouse':
      return NAV_BADGE_KEYS.QUALITY_CHECK_WAREHOUSE;
    default:
      return null;
  }
};

export const resolveNavBadgeCount = ({ badgeKey, countsByKey, role }) => {
  if (!badgeKey) return 0;

  if (badgeKey === NAV_BADGE_KEYS.CREDIT_APPROVAL && normalizeRole(role) !== 'accounts') {
    return 0;
  }

  let resolvedKey = badgeKey;

  if (badgeKey === NAV_BADGE_KEYS.BILL_OF_MATERIAL) {
    resolvedKey = getBillOfMaterialBadgeKey(role);
  }

  if (badgeKey === NAV_BADGE_KEYS.PACKAGING_AND_STAGING) {
    resolvedKey = getPackagingAndStagingBadgeKey(role);
  }

  if (badgeKey === NAV_BADGE_KEYS.DELIVERY_CHALLAN) {
    resolvedKey = getDeliveryChallanBadgeKey(role);
  }

  if (badgeKey === NAV_BADGE_KEYS.QUALITY_CHECK) {
    resolvedKey = getQualityCheckBadgeKey(role);
  }

  return countsByKey[resolvedKey] || 0;
};
